<template>
  <div class="notification">
    <div class="title fs24">{{title}}</div>
    <div class="time fs22">{{date}}</div>
  </div>
</template>

<script>
 export default {
   name: '',
   props: ['title', 'date']
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .notification{
   width: 27vw;
   height: 8vw;
   margin-top: 1vw;
   background-color: #F4F5F9;
   box-sizing: border-box;
   padding: 1.6vw;
   display:flex;
   flex-direction:column;
   align-items:flex-start;
   justify-content: space-between;
 }
 .title{
   margin-right: 0.5em;
   color: black;
 }
 .time{
   color:#6A6A6A;
   align-self: flex-end;
 }
</style>
